<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="banner">
      <el-carousel height="600px">
        <el-carousel-item v-for="(item, index) in banners" :key="index">
          <img :src="item.image" :alt="item.title">
          <div class="banner-content">
            <h2>{{ item.title }}</h2>
            <p>{{ item.description }}</p>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 核心优势 -->
    <div class="advantages section">
      <h2 class="section-title">核心优势</h2>
      <el-row :gutter="30">
        <el-col :sm="12" :md="6" v-for="(item, index) in advantages" :key="index">
          <div class="advantage-card">
            <i :class="item.icon"></i>
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 产品服务 -->
    <div class="products section">
      <h2 class="section-title">产品服务</h2>
      <el-row :gutter="30">
        <el-col :sm="24" :md="8" v-for="(product, index) in products" :key="index">
          <el-card class="product-card" shadow="hover">
            <img :src="product.image" :alt="product.title">
            <h3>{{ product.title }}</h3>
            <p>{{ product.description }}</p>
            <el-button type="primary" @click="goToProduct(product)">了解更多</el-button>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 合作伙伴 -->
    <div class="partners section">
      <h2 class="section-title">合作伙伴</h2>
      <div class="partner-list">
        <img v-for="(partner, index) in partners" :key="index"
          :src="partner.logo" :alt="partner.name">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      banners: [
        {
          image: require('../assets/products-banner.jpg'),
          title: '智能网络解决方案',
          description: '为企业提供全方位的网络技术服务'
        },
        {
          image: require('../assets/products-banner.jpg'),
          title: '网络安全防护',
          description: '保障企业数据安全，构建可信网络环境'
        },
        {
          image: require('../assets/products-banner.jpg'),
          title: '物联网应用开发',
          description: '助力企业数字化转型，实现智能化升级'
        }
      ],
      advantages: [
        {
          icon: 'el-icon-cpu',
          title: '技术创新',
          description: '持续研发创新，掌握核心技术'
        },
        {
          icon: 'el-icon-user',
          title: '专业团队',
          description: '资深技术专家，丰富项目经验'
        },
        {
          icon: 'el-icon-service',
          title: '优质服务',
          description: '7*24小时技术支持，快速响应'
        },
        {
          icon: 'el-icon-medal',
          title: '品质保证',
          description: 'ISO认证，质量有保障'
        }
      ],
      products: [
        {
          image: require('../assets/products-banner.jpg'),
          title: '智能网络管理平台',
          description: '集中管理、智能监控、故障预警'
        },
        {
          image: require('../assets/products-banner.jpg'),
          title: '安全态势感知系统',
          description: '实时监测、威胁分析、应急处置'
        },
        {
          image: require('../assets/products-banner.jpg'),
          title: '物联网应用平台',
          description: '设备接入、数据分析、智能控制'
        }
      ],
      partners: [
        { logo: require('../assets/products-banner.jpg'), name: '合作伙伴1' },
        { logo: require('../assets/products-banner.jpg'), name: '合作伙伴2' },
        { logo: require('../assets/products-banner.jpg'), name: '合作伙伴3' },
        { logo: require('../assets/products-banner.jpg'), name: '合作伙伴4' }
      ]
    }
  },
  methods: {
    goToProduct(product) {
        console.log('Go to product:', product)
      this.$router.push('/products')
    }
  }
}
</script>

<style scoped>
.home {
  width: 100%;
}

.banner {
  margin-top: -60px;
}

.banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  text-shadow: 0 2px 4px rgba(0,0,0,0.5);
}

.banner-content h2 {
  font-size: 48px;
  margin-bottom: 20px;
}

.section {
  padding: 80px 0;
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  text-align: center;
  font-size: 36px;
  margin-bottom: 50px;
  color: #333;
}

.advantage-card {
  text-align: center;
  padding: 30px;
}

.advantage-card i {
  font-size: 48px;
  color: #409EFF;
  margin-bottom: 20px;
}

.advantage-card h3 {
  margin-bottom: 15px;
  color: #333;
}

.product-card {
  margin-bottom: 30px;
  text-align: center;
}

.product-card img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin-bottom: 20px;
}

.product-card h3 {
  margin-bottom: 15px;
  color: #333;
}

.product-card p {
  margin-bottom: 20px;
  color: #666;
}

.partner-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  align-items: center;
}

.partner-list img {
  width: 100%;
  max-width: 200px;
  filter: grayscale(100%);
  transition: filter 0.3s;
}

.partner-list img:hover {
  filter: grayscale(0);
}

@media screen and (max-width: 768px) {
  .banner-content h2 {
    font-size: 32px;
  }

  .section {
    padding: 40px 20px;
  }

  .partner-list {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>